import useBacktestStore from '../Store/backtestStore';

let ws = null;

export function connectBacktestWs() {
  // const WS_URL = 'ws://localhost:4001/ws';
  const WS_URL = 'wss://one-dte-iron-condor-backend-22b99d211e32.herokuapp.com/ws';

  if (ws) {
    console.warn('[Backtest WS] Already connected');
    return () => {};
  }

  const socket = new WebSocket(WS_URL);
  ws = socket;

  socket.onopen = () => {
    console.log('[Backtest WS] Connected');

    // 🔒 use *socket*, not ws
    socket.send(JSON.stringify({
      type: 'get_whitepaper_equity'
    }));
  };

  socket.onmessage = (event) => {
    let msg;
    try {
      msg = JSON.parse(event.data);
    } catch {
      return;
    }

    if (msg.type === 'whitepaper_equity') {
      const series = Array.isArray(msg.equitySeries)
        ? msg.equitySeries
        : [];

      console.log('[Backtest WS] Equity rows received:', series.length);

      useBacktestStore
        .getState()
        .setEquitySeries(series);
    }
  };

  socket.onerror = (err) => {
    console.error('[Backtest WS] Error:', err);
  };

  socket.onclose = () => {
    console.log('[Backtest WS] Disconnected');
    ws = null;
  };

  // cleanup
  return () => {
    try {
      socket.close();
    } catch (_) {}
    if (ws === socket) ws = null;
  };
}
